export function formatVendorArray(
  arr: (string | number)[] | string[] | string | null | undefined
): string {
  if (arr === null || arr === undefined) {
    return "—";
  }
  if (Array.isArray(arr)) {
    return arr.length ? arr.map(String).join(", ") : "—";
  }
  if (typeof arr === "string") {
    try {
      const parsed = JSON.parse(arr) as unknown;
      return Array.isArray(parsed) ? parsed.map(String).join(", ") : arr || "—";
    } catch {
      return arr ? arr : "—";
    }
  }
  return "—";
}
